import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";

export async function update(id, quantity) {
  const axios = axiosInstance().primoLab;
  let message = [];

  await axios
    .put(`/receipts`, {
        id: id,
        quantity: quantity,
    })
    .then(async (response) => {
      message = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { message };
}
